import FirebaseFirestore from 'firebase/firestore';

export enum Week {
  SUN = 'SUN',
  MON = 'MON',
  TUE = 'TUE',
  WED = 'WED',
  THU = 'THU',
  FRI = 'FRI',
  SAT = 'SAT',
}

export enum OrderType {
  STORE_PICKUP = 'STORE_PICKUP',
  STORE_DELIVERY = 'STORE_DELIVERY',
  STORE_PREORDER_PICKUP = 'STORE_PREORDER_PICKUP',
  STORE_PREORDER_DELIVERY = 'STORE_PREORDER_DELIVERY',
  PLATFORM_PICKUP = 'PLATFORM_PICKUP',
  PLATFORM_DELIVERY = 'PLATFORM_DELIVERY',
  PLATFORM_PREORDER_PICKUP = 'PLATFORM_PREORDER_PICKUP',
  PLATFORM_PREORDER_DELIVERY = 'PLATFORM_PREORDER_DELIVERY',
  PLATFORM_PICKUP_POINT = 'PLATFORM_PICKUP_POINT',
}

export enum DeliveryPartner {
  LALAMOVE_MOTORCYCLE = 'LALAMOVE_MOTORCYCLE',
  LALAMOVE_MPV = 'LALAMOVE_MPV',
  PANDAGO = 'PANDAGO',
  UFAST = 'UFAST',
  DEMO = 'DEMO',
}

export enum PaymentType {
  NONE = 'NONE',
  CASH = 'CASH',
  CREDIT = 'CREDIT',
  LINEPAY = 'LINEPAY',
  PLATFORM = 'PLATFORM',
  ENTERPRISE = 'ENTERPRISE',
}

export enum Role {
  ADMINS = 'ADMINS',
  STUFFS = 'STUFFS',
  DRIVERS = 'DRIVERS',
}

export enum SocialMedia {
  FB = 'FB',
  LINE = 'LINE',
  IG = 'IG',
}

export enum OrderFrom {
  STORE = 'STORE',
  PLATFORM = 'PLATFORM',
}

export enum ContainerOwner {
  PLATFORM = 'PLATFORM',
  DRIVER = 'DRIVER',
  CUSTOMER = 'CUSTOMER',
  STORE = 'STORE',
  RETURN_POINT = 'RETURN_POINT',
}

export enum TzWalletSystem {
  TCUST = 'TCUST',
  HOSPITAL = 'HOSPITAL',
}

export type Schedule = {
  start: number;
  end: number;
};

export type OperatingTime = Record<Week, Array<Schedule>>;

export type Location = {
  address: string;
  geoPoint: FirebaseFirestore.GeoPoint;
};

export type Inventory = {
  default: number;
  reserved: Record<string, number>;
  current: Record<string, number>;
};

export type PreOrderSetting = {
  afterHours: number;
  beforeHours: number;
  schedule: OperatingTime;
};

export type ShippingFeeSetting = {
  baseFee: number;
  freeLimit: number;
  rates: Array<{ min: number; max: number; price: number }>;
  priceThreshold: Array<{ cost: number; distance: number }>;
  subsidies: Array<{ cost: number; share: number }>;
  cashHandlingFeeForCustomer: number;
};

export type UPayPrivate = {
  apiKey: string;
  paramKey: string;
  uid: string;
  url: {
    failed: string;
    success: string;
  };
};

export type LinePayPrivate = {
  baseUrl: string;
  channelId: string;
  channelSecretKey: string;
};
